export default __webpack_public_path__ + "static/black_white_seduction-c82f49ddc7f3b5dfcf8298c13473d507.png";